import React, { useEffect, useState } from 'react'
import { RecoilRoot } from 'recoil'
import RecoilNexus from 'recoil-nexus'
import { RouterProvider, createHashRouter } from 'react-router-dom'
import Main from './components/Main'
import Toasts from './components/Toasts'
import Charts from './components/charts'
import { GAinit, GAtrack } from './services/ga'
import { useWalletContext } from './components/WalletContext'
// import { initProvider } from './services/amm'
import { useStoreActions, useStoreState } from './model/hooks'
import * as Sentry from '@sentry/react'
import { Network } from './services/token.service'
import { Leaderboard } from './components/Leaderboard/Leaderboard'
import { TokenPage } from './components/TokenPage/TokenPage'
import { IncentivePage } from './components/IncentivePage/IncentivePage'
import PositionsPage from './components/PositionsPage/PositionsPage'
import PositionPage from './components/PoolsPage/PositionPage/PositionPage'
import CreatePosition from './components/PoolsPage/CreatePosition'

Sentry.init({
    dsn: 'https://25f17dd087f081b9d52ba6dc52c86209@o4504986261389312.ingest.sentry.io/4506806170419200',
    integrations: [Sentry.browserTracingIntegration()],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

function App() {
    const { networkName: network, walletAddress, connect } = useWalletContext()
    const loadTokens = useStoreActions((actions) => actions.tokens.loadTokens)
    const loadPools = useStoreActions((actions) => actions.clPools.loadPools)
    const loadBalances = useStoreActions((actions) => actions.tokens.loadBalances)
    const tokens = useStoreState((state) => state.tokens.tokens[network!])
    const [loadBalancesIntervalId, setLoadBalancesIntervalId] = useState(undefined as unknown as NodeJS.Timeout)
    const loadPrices = useStoreActions((actions) => actions.pricing.loadPrices)

    // const [didConnect, setDidConnect] = useState(false)
    useEffect(() => {
        // console.log('APPPPP didConnect ', didConnect)
        GAtrack('Version - 1.0', 'Version - 1.0', 'Version - 1.0')
    }, [])

    // useEffect(() => {
    //     if (network) initProvider(network as Network)
    // }, [network])

    useEffect(() => {
        const isDisconnected = window.localStorage.getItem('isDisconnected')
        if (isDisconnected === 'false' || !isDisconnected) connect(true)
    }, [])

    useEffect(() => {
        // connect(true)

        loadPrices()
        const intervalId = setInterval(() => {
            loadPrices()
        }, 180000)

        return () => {
            clearInterval(intervalId)
        }
    }, [])

    useEffect(() => {
        loadTokenBalance()
    }, [tokens, walletAddress])

    useEffect(() => {
        loadData()
    }, [network])

    async function loadData() {
        await loadTokens({ network: network ? (network as Network) : 'mainnet-alpha' })
        loadPools({ network: network ? (network as Network) : 'mainnet-alpha' })
    }
    // async function loadNumOfPools() {
    //     await loadPoolsAmount({ network })
    // }

    useEffect(() => {
        GAinit()
    }, [])

    function loadTokenBalance() {
        if (!tokens || Object.keys(tokens).length === 0 || !walletAddress) return
        loadBalances({ network: network as Network, walletAddress })

        if (loadBalancesIntervalId) {
            clearInterval(loadBalancesIntervalId)
            setLoadBalancesIntervalId(undefined as unknown as NodeJS.Timeout)
        }
        const intervalId = setInterval(async () => {
            loadBalances({ network: network as Network, walletAddress })
        }, 60000)
        setLoadBalancesIntervalId(intervalId)
    }

    const router = createHashRouter([
        {
            path: '/',
            element: <Main />
        },
        {
            path: '/swap',
            element: <Main />
        },
        {
            path: '/positions',
            element: <PositionsPage />
        },
        {
            path: '/position',
            element: <PositionPage />
        },
        {
            path: '/create-position',
            element: <CreatePosition />
        },
        {
            path: '/charts',
            element: <Charts />
        },
        {
            path: '/rewards',
            element: <IncentivePage />
        },
        {
            path: '/charts/:address',
            element: <Charts />
        },
        {
            // <<<<<<< HEAD
            path: '/leaderboard',
            element: <Leaderboard />
            // =======
        },
        {
            path: 'charts/token/:address',
            element: <TokenPage />
            // >>>>>>> create_pool_page
        }
    ])

    return (
        <RecoilRoot>
            <RecoilNexus />
            <Toasts />
            <RouterProvider router={router}></RouterProvider>
        </RecoilRoot>
    )
}

export default App
